import { createGlobalStyle } from 'styled-components';
import { theme } from './themes';
import { Rubik } from 'next/font/google';

const rubik = Rubik({
  subsets: ['latin', 'cyrillic', 'cyrillic-ext'],
  display: 'swap',
});

const GlobalStyleComponent = createGlobalStyle`

html {
  font-family: ${rubik.style.fontFamily} !important; 
  background-color: ${theme.colors.background};
}

  body {
    --app-safe-area-top: 0px;
    --app-safe-area-right: 0px;
    --app-safe-area-bottom: 0px;
    --app-safe-area-left: 0px;
    --app-header-height: 64px;
    --app-mobile-menu-height: 60px;
    --app-mobile-menu-landscape-width: 64px;
    --app-mobile-menu-total-height: calc(
      var(--app-mobile-menu-height) + var(--app-safe-area-bottom)
    );
    background-color: ${theme.colors.background};
    color: ${theme.colors.white};
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
  user-select: none;

  &.capacitor-ios {
    --app-safe-area-top: env(safe-area-inset-top, 0px);
    --app-safe-area-right: env(safe-area-inset-right, 0px);
    --app-safe-area-bottom: env(safe-area-inset-bottom, 0px);
    --app-safe-area-left: env(safe-area-inset-left, 0px);
    padding-top: 0;
  }

   @media (orientation : landscape) {
      //padding-right: 50px;//move to MobileMenuWrapper for reward compatibility
  }
  @media (min-width: 1024px) {
      padding-right: 0px;
  }
  }

  .flex-1 {
    flex:1
  }

  * {
    padding: ${theme.RANGE.NONE};
    margin: ${theme.RANGE.NONE};
    outline: none;
    font-family: ${rubik.style.fontFamily} !important; 
    box-sizing: border-box; 
    text-decoration: none; 
    letter-spacing: -0.015em;
    /* user-select: none; */
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(65, 77, 107, 0.40);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(65, 77, 107, 0.60);
  }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
[data-radix-popper-content-wrapper] {
  z-index: 100 !important;


  @media (max-width: 768px) {
    min-width: 100% !important;
    max-height: calc(100vh - 115px) !important;
    overflow-y: scroll;

    &:has(> [data-daily-bonus-hint]) {
      min-width: max-content !important;
      overflow: visible;
    }
  }
}
.my-custom-popover-class {
  background-color: rgba(27, 32, 45, 0.96);
  color:#EDEFF5;
}
.driver-popover-arrow {
 
  content: "";
    position: absolute;
    border: 5px solid rgba(27, 32, 45, 0.96);
}

.driver-popover-arrow-side-left {
    left: 100%;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-top-color: transparent;
}

.--fill {
  padding-right:0px;
}

html[data-has-session="true"] [data-auth] {
  display: none !important;
}

:root {
  --guest-only-display: block;
  --session-only-display: none;
}

html[data-has-session="true"] {
  --guest-only-display: none;
  --session-only-display: block;
}

[data-guest-only] {
  display: var(--guest-only-display);
}

[data-session-only] {
  display: var(--session-only-display);
}
`;

export default GlobalStyleComponent;
